import React from 'react';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from '../components/common/react-notifications';
import Api from '../services/Api';

class KycPolicyForm extends React.Component {
  constructor(props) {
    super(props);
    this.firstLevel = {
      level: 1,
      items: [],
      fiat: {
        deposit: {
          max24h: null,
          max30d: null,
        },
        withdraw: {
          max24h: null,
          max30d: null,
        }
      },
      crypto: {
        deposit: {
          max24h: null,
          max30d: null,
        },
        withdraw: {
          max24h: null,
          max30d: null,
        }
      }
    };
  }

  createPolicy = async values => {
    const {t, fireFetchData} = this.props;
    try {
      await Api.invoke(
        'POST',
        '/admin-ui/kyc-policies',
        {
          ...values,
          levels: [this.firstLevel]
        },
      );
      NotificationManager.success(t('Policy created successfully'), t('Message'));
      ModalManager.close({
        isOpen: false
      });
      fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updatePolicy = async values => {
    const {t, policy, fireFetchData} = this.props;
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/kyc-policies',
        {
          ...values,
          id: policy.id
        },
      );
      NotificationManager.success(t('Policy updated successfully'), t('Message'));
      ModalManager.close({
        isOpen: false
      });
      fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  }

  render() {
    const {t, policy} = this.props;
    return(
      <FinalForm
        onSubmit={policy ? this.updatePolicy : this.createPolicy}
        initialValues={{name: policy ? policy.name : undefined}}
        render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <TextField item={{
                    name: 'name',
                    i18n: t('Name'),
                    type: 'text',
                    required: true,
                  }}/>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {policy ? t('Update') : t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(KycPolicyForm);
